import { Button, Dialog, DialogTitle } from '@mui/material';
import './SimpleDialog.scss';
import { Row } from '../Row';

export const SimpleDialog = ({ title, options, open, onClose }) => {
    const handleClose = () => {
        onClose(null);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <div  className="SimpleDialog">
                <DialogTitle>{title}</DialogTitle>
                <Row>
                    {options.map(option => (
                        <Button 
                            key={option.key}
                            variant='contained'
                            onClick={() => handleListItemClick(option.key)}
                        >
                            {option.text}
                        </Button>
                    ))}
                </Row>
            </div>
        </Dialog>
    );
};